__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/ef9e37624909cf5643129644a5e79d97ec36578b/_next/";